import { render, staticRenderFns } from "./ProductCategoryList.pug?vue&type=template&id=b55dba8c&scoped=true&lang=pug&"
import script from "./ProductCategoryList.js?vue&type=script&lang=js&"
export * from "./ProductCategoryList.js?vue&type=script&lang=js&"
import style0 from "./ProductCategoryList.sass?vue&type=style&index=0&id=b55dba8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55dba8c",
  null
  
)

component.options.__file = "ProductCategoryList.vue"
export default component.exports